import { Link, useNavigate } from 'react-router-dom';
import { useRef, useCallback } from 'react';
import { resetScrollForRouteChange } from '../../utils/scrollToTop';

import useGsapSection from '../../hooks/useGsapSection';

import useGsapInView from '../../hooks/useGsapInView';

import { ClipRevealText } from '../TextEffects';



const CaseStudyNext = ({ next, label = 'Next project' }) => {
  const ref = useRef(null);
  const titleRef = useRef(null);
  const navigate = useNavigate();
  const inView = useGsapSection(ref);
  const titleInView = useGsapInView(titleRef);

  const goNext = useCallback(
    (e) => {
      e.preventDefault();
      resetScrollForRouteChange();
      navigate(next.path);
    },
    [navigate, next?.path],
  );

  if (!next) return null;



  const showArrow = next.showArrow !== false;



  return (

    <section

      className={`cs-next${next.variant ? ` is-${next.variant}` : ''}`}

      ref={ref}

      data-testid="case-study-next"

    >

      <Link to={next.path} className="cs-next-link" onClick={goNext}>

        <span className="cs-next-label gsap-reveal">{label}</span>

        <span className="cs-next-title-row">

          <h2 ref={titleRef} className="cs-next-title">

            <ClipRevealText
              key={next.title}
              text={next.title}
              delay={0.05}
              externalInView={titleInView}
            />

          </h2>

          {showArrow && (

            <span className="cs-next-arrow gsap-reveal" aria-hidden="true">

              ↗

            </span>

          )}

        </span>

      </Link>

    </section>

  );

};



export default CaseStudyNext;

